// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b25d8137","845":"14b9bc09"}[chunkId] + ".chunk.js";
};